var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('span',[_vm._v("私有化部署")])])
}
var staticRenderFns = []

export { render, staticRenderFns }